export default __webpack_public_path__ + "static/media/people-together.86355295.png";